import { useOutletContext } from 'react-router-dom';
import type { ProjectSummaryOutletContext } from '../pages/ProjectSummary';
import type { SiteConfig } from '../types/project.types';

/**
 * The ProjectSummary layout's site, for a routed child's tab row (SiteAlarms,
 * SiteContacts, SiteMarket), so site-gated tabs (Market, djin-cloud#1089) show on
 * every routed page. Undefined outside the layout (a page rendered on its own, as in
 * its tests): gated tabs are then hidden, never guessed.
 *
 * A module of its own, and a type-only import of the layout, so a routed page does not
 * pull the layout's socket and telemetry hooks in with it.
 */
export function useProjectSummarySite(): SiteConfig | undefined {
  return useOutletContext<ProjectSummaryOutletContext | null>()?.site ?? undefined;
}
